/* eslint-disable react/forbid-dom-props */
import { ReactNode } from 'react';
import { RenderIf } from 'react-rainbow-components';
import LoadingShape from 'components/LoadingShape';
import { HealthScoreComponentStatus, MetricDefinition } from '../../types';
import {
    ChangeContainer, HealthMetricCardContainer, IconContainer, ValueContainer,
} from './styled';
import getValue from './helpers/getValue';
import MetricChange from '../../MetricChange';

export interface HealthMetricCardProps {
    isLoading?: boolean;
    metricDefinition?: MetricDefinition;
    /** Win rate etc. when the main value is custom (Sales). */
    changeMetricDefinition?: MetricDefinition;
    title: string;
    value?: number | string | ReactNode;
    valueLabel?: string;
    change?: number;
    status?: HealthScoreComponentStatus;
    icon?: ReactNode;
}

const HealthMetricCard = ({
    isLoading,
    metricDefinition,
    changeMetricDefinition,
    value,
    change,
    status,
    icon,
    title,
    valueLabel,
}: HealthMetricCardProps) => {
    if (isLoading) {
        return (
            <HealthMetricCardContainer>
                <div className="rainbow-flex rainbow-flex_column" style={{ width: '100%' }}>
                    <LoadingShape shape="rounded-rect" width="100%" height="16px" />
                    <LoadingShape shape="rounded-rect" width="50%" height="24px" />
                </div>
            </HealthMetricCardContainer>
        );
    }

    const valueComponent = getValue({ value, valueLabel, valueFormat: metricDefinition?.format });
    const changeComponent = typeof change === 'number' ? change : change;
    const changeDef = changeMetricDefinition ?? metricDefinition;

    return (
        <HealthMetricCardContainer $status={status}>
            <RenderIf isTrue={icon}>
                <IconContainer $status={status}>
                    {icon}
                </IconContainer>
            </RenderIf>
            <div style={{ width: '100%' }}>
                <h3>{title}</h3>
                <ValueContainer>
                    {valueComponent}
                    <ChangeContainer>
                        <MetricChange
                            value={changeComponent}
                            valueFormat={changeDef?.format}
                            goodWhen={changeDef?.goodWhen}
                        />
                    </ChangeContainer>
                </ValueContainer>
            </div>
        </HealthMetricCardContainer>
    );
};

export default HealthMetricCard;
